import { z } from 'zod';

import { versionInformationSchema } from '../../../shared/source/data-contract/job-profile-versions';
import { languageCodeSchema } from '../../../shared/source/internationalization';
import { jobArchitectureGenerationInfoSchema } from '../job-architecture/job-architecture';
import {
    creatorSchema,
    jobArchitectureProfileReviewerSchema,
    jobProfileLegacySchema,
} from '../job-profile/job-profile-schema';

export const actionsSchema = z.object({
    canAssignReviewer: z.boolean(),
    canEdit: z.boolean(),
    canPublish: z.boolean().optional(),
    canReadDebugInfo: z.boolean(),
});

export const jobRoleStatisticsSchema = z.object({
    profiles: z.number(),
    reviewed: z.number(),
    reviewers: z.number(),
});

export const jobRoleGenerationInfoStateSchema = z.enum(['queued', 'started', 'finished', 'failed']);

export const jobRoleGenerationInfoSchema = z.object({
    createdAt: z.iso.datetime(),
    inProgress: z.boolean(),
    state: jobRoleGenerationInfoStateSchema,
    updatedAt: z.iso.datetime(),
});

export const translationSchema = z.object({
    description: z.string().optional(),
    language: languageCodeSchema,
    title: z.string(),
});

export const jobRoleDetailsSchema = z
    .object({
        id: z.uuid(),
        actions: actionsSchema,
        architectureId: z.uuid(),
        childCount: z.number().int().nonnegative(),
        creator: creatorSchema.optional(),
        externalId: z.string().optional(),
        generationInfo: jobRoleGenerationInfoSchema.optional(),
        jobProfile: jobProfileLegacySchema.optional(),
        parentId: z.uuid(),
        profileGenerationInfo: jobArchitectureGenerationInfoSchema.optional(),
        reviewer: jobArchitectureProfileReviewerSchema.optional(),
        statistics: jobRoleStatisticsSchema,
        title: z.string(),
        translations: translationSchema.array(),
        versionInfo: versionInformationSchema.optional(),
    })
    .transform((jobRoleDetails) => ({
        ...jobRoleDetails,
        type: 'job-role' as const,
    }));

export type JobRoleDetails = z.infer<typeof jobRoleDetailsSchema>;
